import React, { useEffect } from "react";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import AssignmentEditForm from "../../components/assignment/AssignmentEditForm";

export default function EditAssignment() {
  useEffect(() => {
    document.title = "Edit assignment";
  });
  return (
    <>
      <Navbar />
      <Container>
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            Edit Assignment
          </h1>
          <AssignmentEditForm />
        </main>
      </Container>
    </>
  );
}
